__turbopack_context__.v({
  "auth-drop-in": "AuthPopover-module__evou9G__auth-drop-in",
  "auth-fade": "AuthPopover-module__evou9G__auth-fade",
  "auth-scale-in": "AuthPopover-module__evou9G__auth-scale-in",
  "close": "AuthPopover-module__evou9G__close",
  "dialog": "AuthPopover-module__evou9G__dialog",
  "overlay": "AuthPopover-module__evou9G__overlay",
  "overlayCentred": "AuthPopover-module__evou9G__overlayCentred",
  "panel": "AuthPopover-module__evou9G__panel",
  "panelCentred": "AuthPopover-module__evou9G__panelCentred",
  "panelDocked": "AuthPopover-module__evou9G__panelDocked",
  "trigger": "AuthPopover-module__evou9G__trigger",
});
